import React from "react";
import AiSelectToolCards, { AI_SELECT_TOOLS } from "./AiSelectToolCards";
import AiMaskPaintControls from "./AiMaskPaintControls";

/**
 * Shared Smart / Brush / Box / Eraser picker + mask size / clear controls.
 * Used by AI remove & replace tools that paint a mask.
 */
export function isMaskSelectGenerateReady(
  toolId,
  hasMask,
  {
    prompt = "",
    promptRequired = false,
  } = {}
) {
  const hasPrompt = Boolean(String(prompt).trim());
  if (promptRequired && !hasPrompt) return false;
  if (toolId === "smart") return true;
  return Boolean(hasMask);
}

const AiMaskSelectToolControls = ({
  paint,
  busy = false,
  sourceImageUrl = null,
  leftPanelRef = null,
  /** Used in brush/box hints — e.g. "text", "object", "watermark" */
  subject = "area",
  disabled = false,
  /** Override tool cards (e.g. brush/box/eraser only — no Smart). */
  tools = AI_SELECT_TOOLS,
}) => {
  const toolId = paint.paintTool;
  const needsMask =
    toolId === "brush" || toolId === "box" || toolId === "eraser";

  const brushHint =
    toolId === "box"
      ? `Drag a box over the ${subject} on the preview, then generate.`
      : toolId === "eraser"
        ? "Erase mask strokes on the preview."
        : `Paint over the ${subject} on the preview, then generate.`;

  return (
    <>
      <div className="aftp-section">
        <p className="aftp-label">Tool</p>
        <AiSelectToolCards
          tools={tools}
          selectedId={toolId}
          boundaryRef={leftPanelRef}
          disabled={busy || disabled}
          onSelect={(id) => {
            paint.setPaintTool(id);
          }}
        />
      </div>

      <AiMaskPaintControls
        {...paint}
        busy={busy}
        sourceImageUrl={sourceImageUrl}
        leftPanelRef={leftPanelRef}
        showToolPicker={false}
        showBrushSize={toolId === "brush" || toolId === "eraser"}
        showBrushHint={needsMask && Boolean(sourceImageUrl) && !paint.hasMask}
        brushHint={brushHint}
      />
    </>
  );
};

export default AiMaskSelectToolControls;
